import { createContext, useContext, useState, useEffect } from "react";

interface IMsgContext {
	show: boolean;
	setShow: React.Dispatch<React.SetStateAction<boolean>>;
	msg: string;
	setMsg: React.Dispatch<React.SetStateAction<string>>;
}

export const MsgContext = createContext({} as IMsgContext);
export const useMsgContext = () => useContext(MsgContext);

const Provider = ({ children }) => {
    const [show, setShow] = useState(false);
	const [msg, setMsg] = useState("");

    useEffect(() => {
        if (!show) setMsg("");
    }, [show])

    useEffect(() => {
        setShow(msg !== '');
    }, [msg])

    const value = {
        show, setShow, msg, setMsg,
    };

    return <MsgContext.Provider value={value}>{children}</MsgContext.Provider>;
}

const obj = {
    Provider,
	Consumer: MsgContext.Consumer,
}

export default obj;